import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
    en: {
        Home: "Home",
        SignInHeader: "Sign in to your account",
    },
    th: {
        Home: "หน้าหลัก",
        SignInHeader: "ลงชื่อเข้าใช้",
        Documentation: "คู่มือ",
        "Contact us": "ติดต่อเรา",
        "Welcome to": "ยินดีต้อนรับ",
        AppName: "Watercare",
        Profile: "โปรไฟล์",
        "Sign in": "ลงชื่อเข้าใช้",
        "Sign out": "ออกจากระบบ",
        Actions: "เมนู",
        "Connection Status": "สถานะการเชื่อมต่อ",
        "Alert Status": "สถานะการแจ้งเตือน",
        "View details": "รายละเอียด",
        Share: "แชร์",
        Remove: "ลบ",
        "Add device": "เพิ่มเซ็นเชอร์",
        "Choose add sensor method": "เลือกวิธีเพิ่มเซ็นเซอร์",
        "Weather Forecast": "พยากรอากาศ",
        "Humidity": "ความชื้น",
        "Notifications": "การแจ้งเตือน",
        "Dashboard": "แดชบอร์ด",
    },
};

const i18n = new VueI18n({
    locale: "th", // set locale
    fallbackLocale: "en", // set fallback locale
    messages, // set locale messages
});

export default i18n;